// extracted by mini-css-extract-plugin
export var list = "ThWWM";
export var listItem = "PObXu";